function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#252C32"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M26.679 18.897c3.07 0 5.558 2.489 5.558 5.558v7.782h-2.224v-7.782c0-1.841-1.493-3.334-3.334-3.334H8.893c-1.842 0-3.335 1.493-3.335 3.334v7.782H3.335v-7.782c0-3.07 2.488-5.558 5.558-5.558zM17.786 3.335c3.683 0 6.67 2.986 6.67 6.67 0 3.683-2.987 6.67-6.67 6.67-3.684 0-6.67-2.987-6.67-6.67 0-3.684 2.986-6.67 6.67-6.67zm0 2.223c-2.456 0-4.447 1.99-4.447 4.446 0 2.456 1.991 4.447 4.447 4.447 2.455 0 4.446-1.99 4.446-4.447 0-2.455-1.99-4.446-4.446-4.446z",
  transform: "translate(-155 -1846) translate(155 1846)"
}))));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.9d6e0e72.svg";
export { ForwardRef as ReactComponent };